import { Button } from "reactstrap";

const ListItemActionButton = ({
  color,
  onClick,
  children,
}: {
  color: string;
  onClick: (x?: any) => void;
  children: any;
}) => {
  return (
    <Button
      className="btn-block btn-submit"
      style={{
        width: 160,
        backgroundColor: color,
        borderWidth: 0,
        fontSize: 14,
        marginLeft: 10,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {children}
    </Button>
  );
};

export default ListItemActionButton;
